import moment from 'moment'

const shigoShis = [
  '子丑',
  '丑子',
  '寅亥',
  '亥寅',
  '卯戌',
  '戌卯',
  '辰酉',
  '酉辰',
  '申巳',
  '巳申',
  '未午',
  '午未',
]

const hankaiShis = [
  '子辰',
  '辰子',
  '辰申',
  '申辰',
  '子申',
  '申子',
  '丑巳',
  '巳丑',
  '巳酉',
  '酉巳',
  '丑酉',
  '酉丑',
  '寅午',
  '午寅',
  '午戌',
  '戌午',
  '寅戌',
  '戌寅',
  '卯未',
  '未卯',
  '未亥',
  '亥未',
  '卯亥',
  '亥卯',
]

const gaiShis = [
  '子未',
  '未子',
  '丑午',
  '午丑',
  '寅巳',
  '巳寅',
  '卯辰',
  '辰卯',
  '亥申',
  '申亥',
  '酉戌',
  '戌酉',
]

const seikikeiShis = ['寅巳', '巳寅', '申巳', '巳申', '寅申', '申寅']
const kokikeiShis = ['丑戌', '戌丑', '戌未', '未戌', '丑未', '未丑']
const taichuShis = [
  '子午',
  '午子',
  '丑未',
  '未丑',
  '寅申',
  '申寅',
  '卯酉',
  '酉卯',
  '辰戌',
  '戌辰',
  '巳亥',
  '亥巳',
]
const tenkokuKans = [
  '甲庚',
  '庚甲',
  '甲戊',
  '戊甲',
  '乙辛',
  '辛乙',
  '乙己',
  '己乙',
  '丙壬',
  '壬丙',
  '丙庚',
  '庚丙',
  '丁辛',
  '辛丁',
  '丁癸',
  '癸丁',
  '戊壬',
  '壬戊',
  '戊甲',
  '甲戊',
  '己乙',
  '乙己',
  '己癸',
  '癸己',
]
const haShis = ['子酉', '酉子', '丑辰', '辰丑', '卯午', '午卯', '未戌', '戌未']

const sekkiList = [
  '立春',
  '雨水',
  '啓蟄',
  '春分',
  '清明',
  '穀雨',
  '立夏',
  '小満',
  '芒種',
  '夏至',
  '小暑',
  '大暑',
  '立秋',
  '処暑',
  '白露',
  '秋分',
  '寒露',
  '霜降',
  '立冬',
  '小雪',
  '大雪',
  '冬至',
  '小寒',
  '大寒',
]

export const phaseMixin = {
  data: () => ({
    // date: '',
    // etoName: '',
    // etoInfo: {
    //   title: '',
    //   imgRef: '',
    //   text: '',
    // },
    // annotation: {
    //   oneself: '',
    //   work: '',
    //   society: '',
    //   rokuyou: '',
    //   senjitsu: ''
    // },
    // sanmeiPhases: [],
  }),
  methods: {
    buildAnnotationOneself(phase) {
      let annotation = ''
      const shiName = phase.nittyu.slice(-1)
      // 1.支合
      if (phase.name === '支合') {
        annotation += '順調 '
      }
      // 2.半会
      if (phase.name === '半会') {
        annotation += 'プライベートに広がり '
      }
      // 3.大半会
      if (phase.name === '大半会') {
        annotation += '大きく広がる '
      }
      // 4.律音
      if (phase.name === '律音') {
        annotation += 'ターニングポイント '
      }
      // 5.害
      if (phase.name === '害') {
        if (shiName === '卯' || shiName === '辰') {
          annotation += '骨 筋肉 胃腸 消化器 '
        } else if (shiName === '寅' || shiName === '巳') {
          annotation += '肝臓 胆嚢 '
        } else if (shiName === '丑' || shiName === '午') {
          annotation += '栄養吸収気管 心臓 '
        } else if (shiName === '子' || shiName === '未') {
          annotation += '腎臓 膀胱 排泄系 '
        } else if (shiName === '亥' || shiName === '申') {
          annotation += '肺・呼吸器 '
        } else if (shiName === '戌' || shiName === '酉') {
          annotation += '自律神経 糖尿病 '
        }
      }
      // 6.刑
      if (phase.name === '自刑') {
        if (shiName === '亥') {
          annotation += '家庭内トラブル '
        } else if (shiName === '午') {
          annotation += '詐欺注意 '
        } else if (shiName === '辰') {
          annotation += '身内トラブル '
        } else if (shiName === '酉') {
          annotation += 'ギャンブル警戒 '
        }
      }
      // 7.旺気刑
      if (phase.name === '旺気刑') {
        annotation += '無礼注意 '
      }
      // 8.生貴刑
      if (phase.name === '生貴刑') {
        annotation += 'プライベートの目下に注意 '
      }
      // 9.庫気刑
      if (phase.name === '庫気刑') {
        annotation += '目上や終わりにトラブル '
      }
      // 10.対沖
      if (phase.name === '対沖') {
        annotation += 'トラブル要素 '
      }
      // 11.破
      if (phase.name === '破') {
        annotation += '最後が美にならない '
      }
      // 12.天剋
      if (phase.name === '天剋地冲') {
        annotation += '破壊要素・方針転換 '
      }
      // 13.納音
      if (phase.name === '納音') {
        annotation += '納める・終わらせる '
      }
      // 14.天中殺
      if (phase.name === '天中殺') {
        annotation += '充電日 '
      }
      return annotation
    },
    buildAnnotationWork(phase) {
      let annotation = ''
      const shiName = phase.nittyu.slice(-1)
      // 1.支合
      if (phase.name === '支合') {
        annotation += '課程や心が充実 '
      }
      // 2.半会
      if (phase.name === '半会') {
        annotation += '仕事に広がり '
      }
      // 3.大半会
      if (phase.name === '大半会') {
        annotation += '大きく広がる '
      }
      // 4.律音
      if (phase.name === '律音') {
        annotation += 'ターニングポイント '
      }
      // 5.害
      if (phase.name === '害') {
        if (shiName === '寅' || shiName === '巳') {
          annotation += '頑張りすぎ 過労 '
        } else if (shiName === '丑' || shiName === '午') {
          annotation += '労して功少ない '
        } else if (shiName === '子' || shiName === '未') {
          annotation += '物事がまとまらない '
        } else if (shiName === '亥' || shiName === '申') {
          annotation += '過労 紛失 '
        } else if (shiName === '戌' || shiName === '酉') {
          annotation += '腎臓・目・骨・生殖器ケア '
        }
      }
      // 6.刑
      // if (phase.name === '自刑') {
      //   if (shiName === '亥') {
      //     annotation += '家庭内トラブル '
      //   } else if (shiName === '午') {
      //     annotation += '詐欺注意 '
      //   } else if (shiName === '辰') {
      //     annotation += '身内トラブル '
      //   } else if (shiName === '酉') {
      //     annotation += 'ギャンブル警戒 '
      //   }
      // }
      // 7.旺気刑
      if (phase.name === '旺気刑') {
        annotation += '近い人との不協和音 '
      }
      // 8.生貴刑
      if (phase.name === '生貴刑') {
        annotation += '目下・部下トラブル '
      }
      // 9.庫気刑
      if (phase.name === '庫気刑') {
        annotation += '目上トラブル '
      }
      // 10.対沖
      if (phase.name === '対沖') {
        annotation += 'トラブル要素 '
      }
      // 11.破
      if (phase.name === '破') {
        annotation += '不安や揺らぎ '
      }
      // 12.天剋
      if (phase.name === '天剋地冲') {
        annotation += '破壊要素・方針転換 '
      }
      // 13.納音
      if (phase.name === '納音') {
        annotation += '納める・終わらせる '
      }
      // 14.天中殺
      if (phase.name === '天中殺') {
        annotation += '充電日 '
      }
      return annotation
    },
    buildAnnotationSociety(phase) {
      let annotation = ''
      const shiName = phase.nittyu.slice(-1)
      // 1.支合
      if (phase.name === '支合') {
        annotation += '仕事がスムーズ・新規 '
      }
      // 2.半会
      if (phase.name === '半会') {
        annotation += '社会的に広がる '
      }
      // 3.大半会
      if (phase.name === '大半会') {
        annotation += '大きな動き '
      }
      // 4.律音
      if (phase.name === '律音') {
        annotation += '継続する事に吉 '
      }
      // 5.害
      if (phase.name === '害') {
        if (shiName === '寅' || shiName === '巳') {
          annotation += 'スタートに難 '
          // } else if (shiName === '丑' || shiName === '午') {
          //   annotation += '労して功少ない '
          // } else if (shiName === '子' || shiName === '未') {
          //   annotation += '物事がまとまらない '
          // } else if (shiName === '亥' || shiName === '申') {
          //   annotation += '過労 紛失 '
        } else if (shiName === '戌' || shiName === '酉') {
          annotation += '高望みがストレス '
        }
      }
      // 6.刑
      // if (phase.name === '自刑') {
      //   if (shiName === '亥') {
      //     annotation += '家庭内トラブル '
      //   } else if (shiName === '午') {
      //     annotation += '詐欺注意 '
      //   } else if (shiName === '辰') {
      //     annotation += '身内トラブル '
      //   } else if (shiName === '酉') {
      //     annotation += 'ギャンブル警戒 '
      //   }
      // }
      // 7.旺気刑
      if (phase.name === '旺気刑') {
        annotation += '礼儀重視 '
      }
      // 8.生貴刑
      if (phase.name === '生貴刑') {
        annotation += '始めにトラブル '
      }
      // 9.庫気刑
      if (phase.name === '庫気刑') {
        annotation += '目上に注意 '
      }
      // 10.対沖
      if (phase.name === '対沖') {
        annotation += '社会的な破壊に使う '
      }
      // 11.破
      if (phase.name === '破') {
        annotation += '予期せぬ事態 '
      }
      // 12.天剋
      if (phase.name === '天剋地冲') {
        annotation += '破壊要素・横の人間関係に注意 '
      }
      // 13.納音
      if (phase.name === '納音') {
        annotation += '社会的に終わらせる事に吉 '
      }
      // 14.天中殺
      if (phase.name === '天中殺') {
        annotation += '充電日 '
      }
      return annotation
    },
    buildAnnotationSenjitsu(phase) {
      let annotation = ''
      if (phase.name === '天赦日') {
        annotation += '最強の大吉日 '
      }
      if (phase.name === '一粒万倍日') {
        annotation += '商売始め・金銭関係に吉、借金・借入は凶 '
      }
      if (phase.name === '不成就日') {
        annotation += '成就しない日とされ事を起こす事が凶 '
      }
      if (phase.name === '三隣亡') {
        annotation += '建築に関して強い凶日 '
      }
      return annotation
    },
    async createSanmeiPhaseDownload(eventType, startDate, endDate) {
      let events = []

      let targetStartDateObj = moment(startDate)
      let targetEndDateObj = moment(endDate)

      while (targetStartDateObj.isSameOrBefore(targetEndDateObj, 'day')) {
        events = events.concat(
          await this.createSanmeiPhaseDownloadMonth(
            eventType,
            targetStartDateObj.format('YYYY-MM-DD')
          )
        )
        targetStartDateObj.add(1, 'months')
      }

      return events
    },

    async createSanmeiPhaseDownloadMonth(eventType, startDate) {
      let events = []

      const startDateObj = new Date(startDate)
      let startDay = 1
      let endDay = this.getLastDate(startDateObj).getDate()
      const targetDateYYYYMM = startDate.slice(0, 8) // YYYY-MM-形式
      // 対象月の始めの日の干支位置計算
      let targetEtoDayIndex = this.etoDayIndex(startDate)
      let oldCalendar = await this.getOldCalendarDownload(
        targetDateYYYYMM.slice(0, 4),
        targetDateYYYYMM.slice(5, 7)
      )

      // 日ごとの位相情報を計算
      // 対象期間(月)分ループ
      for (let i = startDay; i <= endDay; i++) {
        const targetDateDD = ('00' + i).slice(-2)
        const targetDateYYYYMMDD = `${targetDateYYYYMM}${targetDateDD}`

        // 必要情報取得
        const targetNittyu = this.eto60[targetEtoDayIndex]
        const targetNittyuKan = targetNittyu.slice(0, 1)
        const targetNittyuShi = targetNittyu.slice(-1)

        let userEtoIndex, userKan, userShi
        switch (eventType) {
        case 'oneself':
        case 'safeDay':
          userEtoIndex = this.user_meishiki.santyu.etoDayIndex
          userKan = this.user_meishiki.santyu.day1
          userShi = this.user_meishiki.santyu.day2
          break
        case 'work':
          userEtoIndex = this.user_meishiki.santyu.etoMonthIndex
          userKan = this.user_meishiki.santyu.month1
          userShi = this.user_meishiki.santyu.month2
          break
        case 'society':
          userEtoIndex = this.user_meishiki.santyu.etoYearIndex
          userKan = this.user_meishiki.santyu.year1
          userShi = this.user_meishiki.santyu.year2
          break
        default:
          break
        }

        const eventTemplate = {
          name: '',
          start: targetDateYYYYMMDD,
          end: targetDateYYYYMMDD,
          color: '',
          type: eventType,
          nittyu: targetNittyu,
        }

        // 選日 + 14.天中殺
        if (eventType === 'oneself' || eventType === 'safeDay') {
          // 選日イベントの設定
          const senjitsuEvents = this.createSenjitsuDownload(
            targetNittyuKan,
            targetNittyuShi,
            targetDateYYYYMMDD,
            oldCalendar
          )
          events.push(...senjitsuEvents)

          // 14.天中殺
          let hasTenshusatsu = false
          // 戌亥天中殺
          if (userEtoIndex >= 1 && userEtoIndex <= 10) {
            if (
              targetNittyuShi === '戌' ||
                            targetNittyuShi === '亥'
            ) {
              hasTenshusatsu = true
            }
            // 申酉天中殺
          } else if (userEtoIndex >= 11 && userEtoIndex <= 20) {
            if (
              targetNittyuShi === '申' ||
                            targetNittyuShi === '酉'
            ) {
              hasTenshusatsu = true
            }
            // 午未天中殺
          } else if (userEtoIndex >= 21 && userEtoIndex <= 30) {
            if (
              targetNittyuShi === '午' ||
                            targetNittyuShi === '未'
            ) {
              hasTenshusatsu = true
            }
            // 辰巳天中殺
          } else if (userEtoIndex >= 31 && userEtoIndex <= 40) {
            if (
              targetNittyuShi === '辰' ||
                            targetNittyuShi === '巳'
            ) {
              hasTenshusatsu = true
            }
            // 寅卯天中殺
          } else if (userEtoIndex >= 41 && userEtoIndex <= 50) {
            if (
              targetNittyuShi === '寅' ||
                            targetNittyuShi === '卯'
            ) {
              hasTenshusatsu = true
            }
            // 子丑天中殺
          } else if (userEtoIndex >= 51 && userEtoIndex <= 60) {
            if (
              targetNittyuShi === '子' ||
                            targetNittyuShi === '丑'
            ) {
              hasTenshusatsu = true
            }
          }
          // event追加
          if (hasTenshusatsu) {
            const event = Object.create(eventTemplate)
            event.name = this.sanmeiPhase.tenshusatsu.name
            event.color = this.sanmeiPhase.tenshusatsu.color
            events.push(event)
          }
        }

        // 1.支合
        if (
          shigoShis.includes(targetNittyuShi + userShi) ||
                    shigoShis.includes(userShi + targetNittyuShi)
        ) {
          const event = Object.create(eventTemplate)
          event.name = this.sanmeiPhase.shigo.name
          event.color = this.sanmeiPhase.shigo.color
          events.push(event)
        }

        // 2.半会, 3.大半会
        if (
          hankaiShis.includes(targetNittyuShi + userShi) ||
                    hankaiShis.includes(userShi + targetNittyuShi)
        ) {
          // 大半合判定
          // event追加
          if (targetNittyuKan === userKan) {
            const event = Object.create(eventTemplate)
            event.name = this.sanmeiPhase.daihankai.name
            event.color = this.sanmeiPhase.daihankai.color
            events.push(event)
          } else {
            const event = Object.create(eventTemplate)
            event.name = this.sanmeiPhase.hankai.name
            event.color = this.sanmeiPhase.hankai.color
            events.push(event)
          }
        }

        // 4.律音
        if (targetNittyu === userKan + userShi) {
          const event = Object.create(eventTemplate)
          event.name = this.sanmeiPhase.ricchin.name
          event.color = this.sanmeiPhase.ricchin.color
          events.push(event)
        }

        // 5.害
        if (
          gaiShis.includes(targetNittyuShi + userShi) ||
                    gaiShis.includes(userShi + targetNittyuShi)
        ) {
          const event = Object.create(eventTemplate)
          event.name = this.sanmeiPhase.gai.name
          event.color = this.sanmeiPhase.gai.color
          events.push(event)
        }

        // 6.自刑
        const jikeiShis = ['辰', '午', '酉', '亥']
        if (
          targetNittyuShi === userShi &&
                    jikeiShis.includes(targetNittyuShi)
        ) {
          const event = Object.create(eventTemplate)
          event.name = this.sanmeiPhase.jikei.name
          event.color = this.sanmeiPhase.jikei.color
          events.push(event)
        }

        // 7.旺気刑
        if (
          targetNittyuShi === '子' && userShi === '卯' ||
                    targetNittyuShi === '卯' && userShi === '子'
        ) {
          const event = Object.create(eventTemplate)
          event.name = this.sanmeiPhase.oukikei.name
          event.color = this.sanmeiPhase.oukikei.color
          events.push(event)
        }

        // 8.生貴刑
        if (
          seikikeiShis.includes(targetNittyuShi + userShi) ||
                    seikikeiShis.includes(userShi + targetNittyuShi)
        ) {
          const event = Object.create(eventTemplate)
          event.name = this.sanmeiPhase.seikikei.name
          event.color = this.sanmeiPhase.seikikei.color
          events.push(event)
        }

        // 9.庫気刑
        if (
          kokikeiShis.includes(targetNittyuShi + userShi) ||
                    kokikeiShis.includes(userShi + targetNittyuShi)
        ) {
          const event = Object.create(eventTemplate)
          event.name = this.sanmeiPhase.kokikei.name
          event.color = this.sanmeiPhase.kokikei.color
          events.push(event)
        }

        // 10.対沖, 12.天剋, 13.納音
        if (
          taichuShis.includes(targetNittyuShi + userShi) ||
                    taichuShis.includes(userShi + targetNittyuShi)
        ) {
          // 納音判定
          // event追加
          if (targetNittyuKan === userKan) {
            const event = Object.create(eventTemplate)
            event.name = this.sanmeiPhase.nacchin.name
            event.color = this.sanmeiPhase.nacchin.color
            events.push(event)
          } else {
            // 天剋判定
            if (
              tenkokuKans.includes(targetNittyuKan + userKan) ||
                            tenkokuKans.includes(userKan + targetNittyuKan)
            ) {
              const event = Object.create(eventTemplate)
              event.name = this.sanmeiPhase.tenkoku.name
              event.color = this.sanmeiPhase.tenkoku.color
              events.push(event)
            } else {
              // 対沖
              const event = Object.create(eventTemplate)
              event.name = this.sanmeiPhase.taichu.name
              event.color = this.sanmeiPhase.taichu.color
              events.push(event)
            }
          }
        }

        // 11.破
        if (
          haShis.includes(targetNittyuShi + userShi) ||
                    haShis.includes(userShi + targetNittyuShi)
        ) {
          const event = Object.create(eventTemplate)
          event.name = this.sanmeiPhase.ha.name
          event.color = this.sanmeiPhase.ha.color
          events.push(event)
        }

        // 安牌日フロー
        if (eventType === 'safeDay') {
          //console.log('##judge test events:', events)
          // 1.支合
          if (
            shigoShis.includes(targetNittyuShi + userShi) ||
                            shigoShis.includes(userShi + targetNittyuShi)
          ) {
            let isSafeDay = events.some(
              (event) =>
                event.start === targetDateYYYYMMDD &&
                            (event.name === '支合' &&
                                event.name !== '不成就日' ||
                                event.name !== '三隣亡')
            )
            // 六曜判定
            let rokuyou = !oldCalendar.datelist[targetDateYYYYMMDD]
              ? ''
              : oldCalendar.datelist[targetDateYYYYMMDD].rokuyou
            if (rokuyou === '赤口' || rokuyou === '仏滅') {
              isSafeDay = false
            }
            if (isSafeDay) {
              const event = Object.create(eventTemplate)
              event.name = '良い日柱支合'
              event.color = 'green accent-1'
              event.nittyu = targetNittyu
              events.push(event)
            }
            //console.log('##safeDay test events:', events)
          }
          events = events.filter(
            (event) =>
              event.name === '良い日柱支合' ||
            event.name === '一粒万倍日' ||
            event.name === '天赦日'
          )
        }

        // 干支番号を更新
        targetEtoDayIndex = (targetEtoDayIndex + 1) % 60
      }
      return events
    },
    async getOldCalendarDownload(startYear, startMonth) {
      let oldCalendar = null
      try {
        const res = await this.$axios.get(
          'https://https://koyomi.zingsystem.com/api/',
          {
            params: {
              mode: 'm',
              cnt: 1,
              targetyyyy: startYear,
              targetmm: startMonth,
              targetdd: '01' // 利用APIの仕様上、日付は1日固定
            },
          }
        )
        oldCalendar = res.data

        // 節気の設定
        // 節気の境目(新暦の月で節気が変わるはじめの日)を取得
        let sekkiDate = ''
        for (let [key, value] of Object.entries(oldCalendar.datelist)) {
          if (value.sekki !== '') {
            sekkiDate = key
            break
          }
        }
        let sekkiIndex =
                    (sekkiList.indexOf(oldCalendar.datelist[sekkiDate].sekki) -
                        1 +
                        24) %
                    24
        let sekkiStr = sekkiList[sekkiIndex]

        // 節目節気より前の節気設定
        for (let [, value] of Object.entries(oldCalendar.datelist)) {
          if (value.sekki === '') {
            value.sekki = sekkiStr
          }
          // 節気が切り替わり時
          else if (sekkiStr !== value.sekki) {
            sekkiIndex = (sekkiIndex + 1) % 24
            value.sekki = sekkiList[sekkiIndex]
            sekkiStr = value.sekki
          }
        }
      } catch (error) {
        //console.error('旧暦取得WebAPI失敗', error)
      }

      return oldCalendar
    },
    createSenjitsuDownload(kan, shi, targetDateYYYYMMDD, oldCalendar) {
      const events = []
      const eventTemplate = {
        name: '',
        start: targetDateYYYYMMDD,
        end: targetDateYYYYMMDD,
        color: '',
        type: 'senjitsu',
        nittyu: kan + shi,
      }
      // 正月：立春・雨水, 二月：啓蟄・春分
      // 三月：清明・穀雨, 四月：立夏・小満
      // 五月：芒種・夏至, 六月：小暑・大暑
      // 七月：立秋・処暑, 八月：白露・秋分
      // 九月：寒露・霜降, 十月：立冬・小雪
      // 十一月：大雪・冬至, 十二月：小寒・大寒

      const sekki = oldCalendar.datelist[targetDateYYYYMMDD].sekki
      const kyurekim = oldCalendar.datelist[targetDateYYYYMMDD].kyurekim
      const kyurekid = oldCalendar.datelist[targetDateYYYYMMDD].kyurekid

      // 三隣亡
      if (
        [
          '立春',
          '雨水',
          '立夏',
          '小満',
          '立秋',
          '処暑',
          '立冬',
          '小雪',
        ].includes(sekki) &&
                    shi === '亥' ||
                [
                  '啓蟄',
                  '春分',
                  '芒種',
                  '夏至',
                  '白露',
                  '秋分',
                  '大雪',
                  '冬至',
                ].includes(sekki) &&
                    shi === '寅' ||
                [
                  '清明',
                  '穀雨',
                  '小暑',
                  '大暑',
                  '寒露',
                  '霜降',
                  '小寒',
                  '大寒',
                ].includes(sekki) &&
                    shi === '午'
      ) {
        const event = Object.create(eventTemplate)
        event.name = this.senjitsu.sanrinbo.name
        event.color = this.senjitsu.sanrinbo.color
        events.push(event)
      }

      // 一粒万倍日
      if (
        ['立春', '雨水'].includes(sekki) &&
                    ['丑', '午'].includes(shi) ||
                ['啓蟄', '春分'].includes(sekki) &&
                    ['酉', '寅'].includes(shi) ||
                ['清明', '穀雨'].includes(sekki) &&
                    ['子', '卯'].includes(shi) ||
                ['立夏', '小満'].includes(sekki) &&
                    ['卯', '辰'].includes(shi) ||
                ['芒種', '夏至'].includes(sekki) &&
                    ['巳', '午'].includes(shi) ||
                ['小暑', '大暑'].includes(sekki) &&
                    ['酉', '午'].includes(shi) ||
                ['立秋', '処暑'].includes(sekki) &&
                    ['子', '未'].includes(shi) ||
                ['白露', '秋分'].includes(sekki) &&
                    ['卯', '申'].includes(shi) ||
                ['寒露', '霜降'].includes(sekki) &&
                    ['酉', '午'].includes(shi) ||
                ['立冬', '小雪'].includes(sekki) &&
                    ['酉', '戌'].includes(shi) ||
                ['大雪', '冬至'].includes(sekki) &&
                    ['亥', '子'].includes(shi) ||
                ['小寒', '大寒'].includes(sekki) && ['卯', '子'].includes(shi)
      ) {
        const event = Object.create(eventTemplate)
        event.name = this.senjitsu.ichiryu.name
        event.color = this.senjitsu.ichiryu.color
        events.push(event)
      }

      // 不成就日
      if (
        [1, 7].includes(kyurekim) &&
                    [3, 11, 19, 27].includes(kyurekid) ||
                [2, 8].includes(kyurekim) &&
                    [2, 10, 18, 26].includes(kyurekid) ||
                [3, 9].includes(kyurekim) &&
                    [1, 9, 17, 25].includes(kyurekid) ||
                [4, 10].includes(kyurekim) &&
                    [4, 12, 20, 28].includes(kyurekid) ||
                [5, 11].includes(kyurekim) &&
                    [5, 13, 21, 29].includes(kyurekid) ||
                [6, 12].includes(kyurekim) &&
                    [6, 14, 22, 30].includes(kyurekid)
      ) {
        const event = Object.create(eventTemplate)
        event.name = this.senjitsu.fujoujunichi.name
        event.color = this.senjitsu.fujoujunichi.color
        events.push(event)
      }

      // 下段：天赦日
      const kanshi = kan + shi
      if (
        ['立春', '雨水', '啓蟄', '春分', '清明', '穀雨'].includes(
          sekki
        ) &&
                    kanshi === '戊寅' ||
                ['立夏', '小満', '芒種', '夏至', '小暑', '大暑'].includes(
                  sekki
                ) &&
                    kanshi === '甲午' ||
                ['立秋', '処暑', '白露', '秋分', '寒露', '霜降'].includes(
                  sekki
                ) &&
                    kanshi === '戊申' ||
                ['立冬', '小雪', '大雪', '冬至', '小寒', '大寒'].includes(
                  sekki
                ) &&
                    kanshi === '甲子'
      ) {
        const event = Object.create(eventTemplate)
        event.name = this.gedan.tenshabi.name
        event.color = this.gedan.tenshabi.color
        events.push(event)
      }

      return events
    },
    getLastDate(date) {
      return new Date(date.getFullYear(), date.getMonth() + 1, 0)
    },
  },
}
